import React from "react";
import { Outlet } from "react-router-dom"; // <-- Импортируем Outlet
import { Box, Paper } from "@mui/material";
import Header from "./components/pageload/Header";
import Footer from "./components/pageload/Footer";

export default function MainLayout() {
  return (
    <Paper>
      <Header />
      <Box
        sx={{
          h: 10,
          mb: 10,
        }}></Box>

      <Outlet />

      <Footer />
    </Paper>
  );
}
